import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-test-webcomponent',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <h1>Test de Integración del WebComponent de Argo</h1>
    <p>El siguiente componente es una aplicación Angular completa, encapsulada y autónoma.</p>

    // <argo-webcomponent></argo-webcomponent>
  `,
  styles: [`
    argo-web-component {
      margin-top: 20px;
    }
  `]
})
export class TestWebcomponentComponent { }
